import { render, staticRenderFns } from "./TasinmazHaczininKaldirilmasiTalepEvrakForm.vue?vue&type=template&id=723b4d22"
import script from "./TasinmazHaczininKaldirilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"
export * from "./TasinmazHaczininKaldirilmasiTalepEvrakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports